export const firebaseConfig = {
  apiKey: "AIzaSyDgLSz7DZRCv3GHQjgT4nb6M0pG1XpoN30",
  authDomain: "twitter-analysis-yuugram.firebaseapp.com",
  databaseURL: "https://twitter-analysis-yuugram.firebaseio.com",
  projectId: "twitter-analysis-yuugram",
  storageBucket: "twitter-analysis-yuugram.appspot.com",
  messagingSenderId: "863606726357"
};


// WEBPACK FOOTER //
// ./src/firebase/config.js